// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 17-code-organization.md
export const APP_SLUG_REGEX = /^[a-z][a-z0-9-]{1,40}[a-z0-9]$/;
export const ORG_SLUG_REGEX = /^[a-z][a-z0-9-]{1,30}[a-z0-9]$/;
/** GitHub org login format (docs/07 §GitHub App creation flow); shared so the
 * wizard's client-side check matches the server's manifest-target validation. */
export const GITHUB_ORG_LOGIN_REGEX = /^[a-zA-Z0-9](?:[a-zA-Z0-9]|-(?=[a-zA-Z0-9])){0,38}$/;
/**
 * A git object hash, abbreviated or full, in either hash algorithm. Shared so every
 * boundary a commit or tree hash crosses — the scanner callback contract, the gate's
 * queue payload — rejects the same values, rather than the innermost one accepting
 * what the outermost refused.
 */
export const GIT_OBJECT_SHA_REGEX = /^[0-9a-f]{7,64}$/;
/**
 * Default OPA policy rows seeded when the install wizard creates the org.
 *
 * Each `policyId` must match a `rule_id` in the shipped `@greenlight/policy` bundle —
 * the gate joins org tuning to rules on this value, so an id with no rule behind it is
 * a check that silently never runs. The `manifest.*` validation rules are deliberately
 * absent: they are always-on manifest validation with no tuning surface.
 */
export const DEFAULT_ORG_POLICIES = [
    { policyId: 'no-secrets-in-code', enforcement: 'warn' },
    { policyId: 'no-critical-cves', enforcement: 'warn' },
    { policyId: 'approved-base-images', enforcement: 'warn' },
    { policyId: 'resource-limits-required', enforcement: 'warn' },
    { policyId: 'no-env-files', enforcement: 'warn' },
];
/**
 * These values must equal the catalog's `defaultEnforcement` for the same ids: a seeded
 * install and an org missing a row would otherwise gate differently on the same check.
 * `@greenlight/policy` owns the catalog and depends on this package, so the assertion
 * lives in that package's tests rather than as an import here.
 */
export const WORKLOAD_KEY_PREFIX_DATA = 'gl_data_';
export const WORKLOAD_KEY_PREFIX_AI = 'gl_ai_';
export const REQUEST_ID_PREFIX = 'req_';
export const WORKLOAD_KEY_RANDOM_BYTES = 32;
/**
 * The single required commit-status context on a protected default branch. Branch
 * protection requires exactly this name and only the control plane writes it, so there
 * is no scanner-set status to forge — the tamper-resistant merge gate
 * (07-source-control-pipeline.md §The policy gate). Both the branch-protection setup
 * and the scanner-complete callback reference this one constant so they cannot drift.
 */
export const GREENLIGHT_REVIEW_STATUS_CONTEXT = 'Greenlight Review and Policy Check';
/**
 * Informational commit-status context carrying the post-merge deploy outcome, posted only
 * on default-branch merge commits (07-source-control-pipeline.md §The policy gate). Distinct
 * from the required gate (GREENLIGHT_REVIEW_STATUS_CONTEXT): deploy runs post-merge, so there
 * is nothing left to gate — this status is never a required branch-protection check.
 */
export const GREENLIGHT_DEPLOY_STATUS_CONTEXT = 'Greenlight Deploy';
/**
 * GitHub's well-known Actions app. Org-authored scanner jobs run as Actions
 * jobs, so the check they post is required through `org_external_checks` bound
 * to this id — IT does not paste an app id on that path.
 */
export const GITHUB_ACTIONS_APP_ID = 15368;
//# sourceMappingURL=index.js.map